import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Grid, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import PlayerCard from "../../components/PlayerCard";
import defaultProfile from "../../assets/images/defaultProfile2.webp";

import TournamentHeader from "./TournamentHeader";
import PlayerStatsModal from "../../components/Modal/PlayerStatsModal";

import { useLeaderBoardMutation } from "../../services/tournamentsAPI"; // <-- ADD THIS

const TeamPlayersScreen = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { teamId, teamName, tournamentData } = location.state || {};
  const tournamentId = tournamentData?._id;

  const allPlayers = tournamentData?.teamMembers || [];

  const playersOfTeam = allPlayers.filter(
    (p) => p.isSold && p.teamId === teamId
  );

  // console.log(playersOfTeam);

  // -----------------------------
  // ⭐ MODAL STATE
  // -----------------------------
  const [openModal, setOpenModal] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);

  // -----------------------------
  // ⭐ LEADERBOARD API
  // -----------------------------
  const [getLeaderboard, { data: leaderboardData, isLoading }] =
    useLeaderBoardMutation();

  useEffect(() => {
    if (!tournamentId) return;

    getLeaderboard({
      criteria: "most_wickets", // you can change criteria dynamically
      tournamentId,
      allTeams: true,
      page: "1",
      limit: "200",
    });
  }, [tournamentId]);

  return (
    <Box sx={{ backgroundColor: "#fff", minHeight: "100vh" }}>
      <TournamentHeader data={tournamentData} />

      <Box sx={{ px: "3rem", py: "2rem" }}>
        {/* HEADER */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: "2.5rem",
            gap: 1.5,
            mt: 1.5,
          }}
        >
          <IconButton
            onClick={() => navigate(-2)}
            sx={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              width: 38,
              height: 38,
            }}
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </IconButton>

          <Typography
            variant="h6"
            sx={{ fontWeight: 500, color: "#000", opacity: 0.7 }}
          >
            Auction
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 600, color: "#DA5332" }}>
            › {teamName}
          </Typography>
        </Box>

        {/* PLAYERS GRID */}
        <Grid container columnSpacing={3} rowSpacing={3}>
          {playersOfTeam.length > 0 ? (
            playersOfTeam.map((player) => (
              <Grid item xs={12} sm={6} md={3} key={player._id}>
                <PlayerCard
                  name={player.playerName}
                  role={player?.playerId?.roleId}
                  image={player?.playerId?.profilePic || defaultProfile}
                  purchasedAt={player.sellingPrice}
                  showActions={false}
                  showPurchase={true}
                  isCaptain={player?.title.includes("Captain")}
                  isIconPlayer={player?.title.includes("Icon Player")}
                />
              </Grid>
            ))
          ) : (
            <Typography sx={{ mt: 4 }}>
              No players purchased by this team.
            </Typography>
          )}
        </Grid>
      </Box>

      {/* PLAYER MODAL */}
      <PlayerStatsModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        player={selectedPlayer}
        leaderboard={leaderboardData?.data?.players || []}
        loading={isLoading} // optional
      />
    </Box>
  );
};

export default TeamPlayersScreen;
